<template>
  <div class="has-fixed-page-subheader">
    <div class="page-subheader d-flex">
      <div class="page-subheader-content d-flex text-center align-self-center">
        <span class="  text-center align-self-center">
          {{ tt.getTranslatedText(activeLang, "updateRequest") }}
          <!-- Update Request -->
        </span>
        <router-link
          :to="
            permissions.crewLeaderDashboard &&
            permissions.crewLeaderDashboard.canAccess
              ? `/crewLeader/dashboard`
              : `/customers/${customerId}`
          "
          class="back-to-dashboard-link   text-center align-self-center"
        >
          {{ tt.getTranslatedText(activeLang, "backToDashboard") }}
          <!-- Back to Dashboard -->
        </router-link>
      </div>
    </div>
    <v-skeleton-loader class="mx-auto ml-2 mr-2" type="card" :loading="loading">
      <!-- <CommunityInfo
        :communityInfo="communityInfo"
        @onRelatedCommunityChanged="showRelatedCommunity"
      />
      <InternalBreadcrumbs :breadcrumbs="breadcrumbs" /> -->
      <v-card
        elevation="0"
        v-if="serviceRequest"
        :loading="serviceRequestProcessing"
      >
        <template slot="progress">
          <v-progress-linear height="10" indeterminate></v-progress-linear>
          <p class="mt-4 text-center">Processing...</p>
        </template>
        <!-- <v-card-title class="orange-bg font-weight-bold white--text">
          Update Request
          <v-divider
            vertical
            thickness="2"
            class="border-opacity-100 mx-3"
            color="white"
          ></v-divider>
          <router-link
            :to="`/customers/${customerId}`"
            class="back-to-dashboard-link"
          >
            Back to Dashboard
          </router-link>
        </v-card-title> -->
        <v-card-actions class="my-2 py-2" v-if="!serviceRequestProcessing">
          <v-btn small class="orange-bg white--text" @click="printRequest">
            {{ tt.getTranslatedText(activeLang, "print") }}
            <!-- Print -->
          </v-btn>
        </v-card-actions>
        <v-card-text class="mt-3" v-if="!serviceRequestProcessing">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "request") }} #:
                      <!-- Request #:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{ serviceRequest.id }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "requestType") }}:
                      <!-- Request Type:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.requestType.name
                    }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "dueDate") }}:
                      <!-- Due Date:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      formatDate(serviceRequest.targetCompletionDate)
                    }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "community") }}:
                      <!-- Community:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.communityName
                    }}</span></v-col
                  >
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "openedBy") }}:
                      <!-- Opened By:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      getCreatedBy(serviceRequest.createdBy)
                    }}</span>
                    <span class="text-h5">{{
                      formatDate(serviceRequest.created)
                    }}</span></v-col
                  >
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "assignedTo") }}:
                      <!-- Assigned To:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      getAssignedTo(serviceRequest.assignedTo)
                    }}</span></v-col
                  >
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <div>
                      <span class="text-h5 text-black font-weight-bold">
                        {{ tt.getTranslatedText(activeLang, "location") }}:
                        <!-- Location:  -->
                      </span>
                      <span class="text-h5">{{ serviceRequest.location }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-row v-if="serviceRequest.isNeighborhoodLoginRequest">
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "hoaOrIndividual") }}:
                      <!-- HOA or Individual:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.isHoaRequest
                        ? "Association Request"
                        : "Individual Home - Extra Service"
                    }}</span></v-col
                  >
                </v-row>
                <v-row v-if="serviceRequest.isNeighborhoodLoginRequest">
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{
                        tt.getTranslatedText(activeLang, "neighborhoodName")
                      }}:
                      <!-- Neighborhood Name:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.neighborhoodName
                    }}</span></v-col
                  >
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "contactName") }}:
                      <!-- Contact Name:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.contactName
                    }}</span></v-col
                  >
                </v-row>
                <v-row v-if="serviceRequest.isNeighborhoodLoginRequest">
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "homeAddress") }}:
                      <!-- Home Address:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.homeAddress
                    }}</span></v-col
                  >
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "contactPhone") }}:
                      <!-- Contact Phone:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.contactPhone
                    }}</span></v-col
                  >
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{ tt.getTranslatedText(activeLang, "contactEmail") }}:
                      <!-- Contact Email:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.contactEmail
                    }}</span></v-col
                  >
                </v-row>
                <v-row v-if="serviceRequest.isNeighborhoodLoginRequest">
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold">
                      {{
                        tt.getTranslatedText(
                          activeLang,
                          "preferredContactMethod"
                        )
                      }}:
                      <!-- Preferred Contact Method:  -->
                    </span>
                  </v-col>
                  <v-col cols="12" md="9">
                    <span class="text-h5">{{
                      serviceRequest.isEmailPreferred ? "Email" : "Phone"
                    }}</span></v-col
                  >
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12" md="3">
                    <span class="text-h5 text-black font-weight-bold"
                      >Attachments
                    </span>
                  </v-col>
                  <v-col>
                    <div
                      v-for="(item, i) in serviceRequest.attachments.$values"
                      :key="'c' + i"
                    >
                      <a :href="item.fileUrl">{{ item.fileName }}</a>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div>
                      <span class="text-h5 text-black font-weight-bold">
                        {{ tt.getTranslatedText(activeLang, "description") }}:
                        <!-- Description:  -->
                      </span>
                    </div>
                    <span class="text-h5">{{
                      serviceRequest.description
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <v-container
            v-for="(item, i) in serviceRequest.comments.$values"
            :key="'c' + i"
          >
            <hr style="background-color: #df6526; height: 1px;" />
            <v-row>
              <v-col class="green--text text-h5"
                >{{ getCreatedBy(item.createdBy) }}
                {{ formatDate(item.created) }}</v-col
              >
            </v-row>
            <v-row>
              <v-col
                ><span class="text-h5">{{ item.description }}</span></v-col
              >
            </v-row>
            <v-row>
              <v-col>
                <div
                  v-for="(commentAttachmentItem, i) in item.attachments.$values"
                  :key="'c' + i"
                >
                  <a target="_blank" :href="commentAttachmentItem.fileUrl">
                    {{ commentAttachmentItem.fileName }}
                  </a>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <hr style="background-color: #df6526; height: 1px;" />
          </v-container>

          <!-- Start Update Service Request section -->
          <v-card id="updateRequestForm" elevation="0" outlined color="#f1f1f1">
            <v-card-text>
              <v-form>
                <v-container>
                  <!--  -->
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-radio-group
                        v-model="requestStatus"
                        row
                        dense
                        :disabled="serviceRequest.isCompleted"
                      >
                        <v-radio
                          label="Open"
                          color="primary"
                          value="open"
                          class="v-radio-no-margin"
                        >
                        </v-radio>
                        <v-radio
                          label="Closed"
                          color="primary"
                          value="complete"
                          class="v-radio-no-margin"
                        >
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <!-- <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        :loading="loadingServiceRequestTypes"
                        v-model="requestType"
                        :items="requestTypeItems"
                        item-text="name"
                        item-value="id"
                        label="* Choose type..."
                        :rules="[v => !!v || 'Type is required']"
                        required
                      >
                      </v-select>
                      <v-checkbox
                        v-model="newRequest.isInternal"
                        label="Internal only"
                      ></v-checkbox>
                    </v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-label class="font-weight-bolder">
                        <span class="text-black font-weight-bold"
                          >Service Type:</span
                        >
                      </v-label>
                      <v-select
                        v-model="requestType"
                        :items="requestTypeItems"
                        item-text="name"
                        item-value="id"
                        label="Service Type..."
                        required
                        solo
                      >
                      </v-select>
                      <!-- <v-radio-group
                        v-model="requestType"
                        label="* Choose Type"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                            md="6"
                            lg="4"
                            v-for="(requestTypeItem, i) in requestTypeItems"
                            :key="'request_type_col_' + i"
                          >
                            <v-radio
                              :value="requestTypeItem.id"
                              :label="requestTypeItem.name"
                            ></v-radio>
                          </v-col>
                        </v-row>
                      </v-radio-group> -->
                      <v-checkbox
                        v-model="newRequest.isInternal"
                        label="Internal only"
                      ></v-checkbox>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-label class="font-weight-bolder">
                        <span class="text-black font-weight-bold"
                          >Assigned To:</span
                        >
                      </v-label>
                      <v-autocomplete
                        v-model="assignedTo"
                        :items="ynTeamItems"
                        item-text="fullName"
                        item-value="id"
                        label="* Assigned to"
                        required
                        clearable
                        solo
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-label class="font-weight-bolder">
                        <span class="text-black font-weight-bold"
                          >Images (up to 8):</span
                        >
                      </v-label></v-col
                    ></v-row
                  >
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                      sm="4"
                      xs="6"
                      v-for="attachment in attachmentsObj"
                      class="darggable-col"
                      :key="attachment.id"
                    >
                      <MediaUploader
                        class="pb-5"
                        uploadType="file"
                        :key="attachment.id"
                        :id="`multiFilePost_${attachment.id}`"
                        :index="attachment.id"
                        :accept="accept"
                        :multiple="true"
                        :extensions="extensions"
                        :sizeImage="10485760"
                        :sizeVideo="104857600"
                        :fileId.sync="attachment.fileId"
                        :file-url.sync="attachment.url"
                        :isUploading.sync="isFileUploading"
                        @onMultipleUploaded="onMultipleAddFile"
                        @onChange="onChange"
                        @onDeleteFile="onDeleteFile"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-label>
                        <span class="text-black font-weight-bold"
                          >Service Request Description:</span
                        >
                      </v-label>
                      <v-textarea
                        v-model="newRequest.description"
                        label="* Update Service Request"
                        required
                        solo
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <!-- <v-row>
                    <v-col cols="12" md="4">
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formattedCompletionDate"
                            label="* Target Completion Date"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            @blur="
                              completionDate = parseDate(
                                formattedCompletionDate
                              )
                            "
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="completionDate"
                          no-title
                          @input="menu1 = false"
                          :rules="[
                            v => !!v || 'Target Completion Date is required'
                          ]"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row> -->

                  <!-- <v-row>
                    <v-col cols="12" md="6">
                      <v-textarea
                        v-model="newRequest.location"
                        label="Please indicate the residence address, address in close proximity or the location in the community (i.e. entrance, pool area, end of Whitehosrse dr., etc.) relating to this service request:"
                      ></v-textarea>
                    </v-col>
                  </v-row> -->

                  <v-row>
                    <v-col cols="12" md="6">
                      <p style="font-size: larger; font-weight: bold;">
                        * Indicates required fields
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-right">
                      <router-link
                        :to="`/customers/${customerId}`"
                        class="text-green"
                      >
                        Cancel
                        <!-- Cancel -->
                      </router-link>
                      <v-btn
                        class="background-color-green text-white ml-4"
                        @click="saveServiceRequest"
                      >
                        Update Service Request
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>

          <!-- End New Service Request section -->
        </v-card-text>
      </v-card>

      <!-- </v-container> -->
    </v-skeleton-loader>
  </div>
</template>

<script>
// import CommunityInfo from "@/view/components/CommunityInfo.vue";
// import InternalBreadcrumbs from "@/view/components/DashboardInternalBreadcrumbs.vue";
import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
import {
  GET_QUERY,
  GET_PAGED,
  POST_DATA,
  API_CUSTOMERS,
  API_EMPLOYEES,
  API_SERVICE_REQUESTS,
  API_SERVICE_REQUEST_TYPES
  // API_SERVICE_REQUEST_PRIORITIES
} from "@/core/store/crud.module";
import crud from "@/core/helpers/crud";
import dateFormatter from "@/core/helpers/dateFormatter";
import stringFormatter from "@/core/helpers/stringFormatter";
import { validationMixin } from "vuelidate";
// import dataModels from "@/core/helpers/datamodels.js";
// import { required } from "vuelidate/lib/validators";
// import moment from "moment";
import MediaUploader from "@/view/components/imageUploader/mediaUploader.vue";
import Mgr from "@/core/services/security.service";
import moment from "moment";

import translatedText from "@/core/helpers/translatedText.js";
import i18nService from "@/core/services/i18n.service.js";
import permissionsHelper from "@/core/helpers/permissionsHelper";

export default {
  mixins: [validationMixin],
  components: {
    // CommunityInfo,
    // InternalBreadcrumbs,
    MediaUploader
  },
  data: () => ({
    tt: {},
    mgr: new Mgr(),
    userInfo: null,
    communityInfo: {},
    serviceRequest: {},
    requestStatus: "open",
    newRequest: {
      communityName: "",
      title: "",
      requestType: "",
      description: "",
      isInternal: false,
      attachments: [],
      // priority: "",
      assignedTo: "",
      targetCompletionDate: null,
      location: ""
    },
    serviceRequestProcessing: false,
    menu1: false,
    completionDate: null,
    formattedCompletionDate: null,
    requestType: "",
    requestTypeItems: [
      // {
      //   name: "Maintanence",
      //   value: "Maintanence"
      // },
      // {
      //   name: "Landscape Installation",
      //   value: "Landscape Installation"
      // },
      // { name: "Irrigation", value: "Irrigation" },
      // { name: "Plant/Turf Health", value: "Plant/Turf Health" },
      // { name: "Storm/Other Damage", value: "Storm/Other Damage" },
      // { name: "Resident Request", value: "Resident Request" },
      // { name: "Customer Complaint", value: "Customer Complaint" },
      // { name: "QA", value: "QA" },
      // { name: "New Opportunity", value: "New Opportunity" },
      // { name: "Other", value: "Other" },

      { name: "General Service", value: "General Service" },
      { name: "Irrigation", value: "Irrigation" },
      { name: "Storm/Other Damage", value: "Storm/Other Damage" },
      { name: "Request for proposal", value: "Request for proposal" }
    ],

    ynTeamItems: [],

    // priority: "",
    // priorityItems: [
    //   { name: "Low", value: "Low" },
    //   { name: "Normal", value: "Normal" },
    //   { name: "High", value: "High" }
    // ],
    assignedTo: { id: "" },
    options: {
      page: 1,
      itemsPerPage: 5
    },
    pageText: "",
    startingAfter: "",
    endingBefore: "",
    previousPage: 1,
    hasMore: false,
    isLoading: false,
    loading: false,
    loadingServiceRequestTypes: false,
    loadingYnTeamItems: false,
    snackbarContent: "",
    snackbarColor: "#F06835",
    breadcrumbs: [],
    attachmentsObj: [{ id: 1, url: null }],
    isFileUploading: false,
    permissions: {}
  }),
  props: {
    customerId: {
      type: [Number, String],
      default: 0
    },
    requestId: {
      type: [Number, String],
      default: 0
    }
  },
  validations() {
    return true;
    // return {
    //   billingInfo: {
    //     subscription: {
    //       nextBillingDates: {
    //         required,
    //         minDate: value =>
    //           dateFormatter.convertToMilliseconds(value) >
    //           dateFormatter.convertToMilliseconds(new Date())
    //       }
    //     }
    //   }
    // };
  },
  watch: {
    completionDate: function() {
      this.formattedCompletionDate = this.formatDate(this.completionDate);
    }
  },
  async mounted() {},
  async created() {
    this.tt = translatedText;
    this.permissions = await permissionsHelper.getPermissions();
    let self = this;
    self.loading = true;
    self.userInfo = await self.mgr.getUser(); //.then(userInfo => (self.userInfo = userInfo));

    // Promise.all([
    //   await self.getComunityInfo(),
    //   await self.getServiceRequest()
    // ]).then(function() {
    //   self.loading = false;
    // });

    await self.getComunityInfo();
    await self.getServiceRequest();
    await self.getServiceRequestTypes();
    await self.getRecipients();

    self.loading = false;
  },
  methods: {
    printRequest() {
      window.print();
    },
    getAssignedTo(assignedTo) {
      return assignedTo?.fullName;
    },
    getCreatedBy(createdBy) {
      return createdBy?.fullName;
    },
    showRelatedCommunity(communityId) {
      this.$router.push({
        name: "CustomerDetails",
        params: { customerId: communityId }
      });
    },
    async setInternalBreadcrumbs() {
      this.breadcrumbs = [
        {
          title: this.communityInfo.name,
          route: "/customers/" + this.customerId
        },
        {
          title: "Service Requests",
          route: "/customers/" + this.customerId + "/requests"
        },
        { title: "Update Service Request" }
      ];
    },
    createBreadcrumb() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Customers", route: "/customers" },
        {
          title: this.communityInfo.name,
          route: "/customers/" + this.customerId
        },
        {
          title: "Service Requests",
          route: "/customers/" + this.customerId + "/requests"
        },
        { title: "Update Service Request" }
      ]);
    },
    async getComunityInfo() {
      let self = this;
      await self.$store
        .dispatch(GET_QUERY, {
          listName: API_CUSTOMERS,
          id: self.customerId
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            self.communityInfo = crud.getPopulatedComunityInfo(response.data);

            self.assignedTo = self.communityInfo.accountManager.id;
            // self.ynTeamItems.push(self.communityInfo.accountManager);

            self.createBreadcrumb();
            self.setInternalBreadcrumbs();

            self.newRequest.communityName = self.communityInfo.name;
          } else {
            self.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }
        });
    },
    async getServiceRequest() {
      let self = this;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_SERVICE_REQUESTS,
          id: this.requestId
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            self.serviceRequest = response.data;

            self.completionDate = new Date(
              self.serviceRequest.targetCompletionDate
            )
              .toISOString()
              .substr(0, 10);

            self.requestType = self.serviceRequest.requestType.id;
            // self.newRequest.targetCompletionDate = moment.utc(
            //   self.serviceRequest.targetCompletionDate
            // );

            let comments = self.serviceRequest.comments.$values;
            if (comments.length > 0) {
              let lastComment = comments.sort((a, b) => {
                return new Date(b.created) - new Date(a.created);
              })[0];
              if (lastComment && lastComment.assignedTo)
                self.assignedTo = lastComment.assignedTo.id;

              if (lastComment) {
                self.serviceRequest.isOpen = lastComment.isOpen;
                self.serviceRequest.isInProcess = lastComment.isInProcess;
                self.serviceRequest.isOnHold = lastComment.isOnHold;
                self.serviceRequest.isCompleted = lastComment.isCompleted;

                self.completionDate = new Date(lastComment.targetCompletionDate)
                  .toISOString()
                  .substr(0, 10);

                self.requestType = lastComment.requestType.id;
              }
              // self.assignedTo = comments.sort((a, b) => {
              //   return new Date(b.created) - new Date(a.created);
              // })[0].assignedTo?.id;
            } else {
              if (self.serviceRequest.assignedTo)
                self.assignedTo = self.serviceRequest.assignedTo.id;
            }

            // if (self.serviceRequest.isOpen) {
            //   self.requestStatus = "open";
            // } else if (self.serviceRequest.isInProcess) {
            //   self.requestStatus = "inProcess";
            // } else if (self.serviceRequest.isOnHold) {
            //   self.requestStatus = "onHold";
            // } else if (self.serviceRequest.isNew) {
            //   self.requestStatus = "new";
            // } else {
            //   self.requestStatus = "complete";
            // }

            if (!self.serviceRequest.isCompleted) {
              self.requestStatus = "open";
            } else {
              self.requestStatus = "complete";
            }
          } else {
            self.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }
        });
    },
    // async getServiceRequestPriorities() {
    //   let self = this;

    //   await self.$store
    //     .dispatch(GET_QUERY, {
    //       listName: API_SERVICE_REQUEST_PRIORITIES
    //     })
    //     .then(response => {
    //       if (response.status >= 200 || response.status <= 204) {
    //         self.priorityItems = response.data.$values;
    //       } else {
    //         self.$snackbar.showMessage({
    //           content: response.data || "Something went wrong!",
    //           color: "red"
    //         });
    //       }
    //     });
    // },
    async getServiceRequestTypes() {
      let self = this;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_SERVICE_REQUEST_TYPES
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            self.requestTypeItems = response.data.$values;

            // if (this.communityInfo.name.includes("Del Webb Grande Dunes")) {
            //   let allowedTypes = [
            //     "General Service",
            //     "Crew, storm or other damage",
            //     "Request For Proposal"
            //   ];

            //   let allowedTypeIds = [6, 11, 12];
            //   this.requestTypeItems = this.requestTypeItems.filter(
            //     el =>
            //       allowedTypes.includes(el.name) ||
            //       allowedTypeIds.includes(el.id)
            //   );
            // } else if (
            //   this.communityInfo.name.includes("Del Webb at Lakewood Ranch") ||
            //   this.communityInfo.name.includes("Del Webb Lakewood Ranch Area")
            // ) {
            //   let disallowedTypes = ["Wildlife Damage", "Mulch Request"];
            //   let disallowedTypeIds = [14, 15];
            //   this.requestTypeItems = this.requestTypeItems.filter(
            //     el =>
            //       !disallowedTypes.includes(el.name) &&
            //       !disallowedTypeIds.includes(el.id)
            //   );
            // } else if (
            //   this.communityInfo.name.includes("Sun City Peachtree Homes")
            // ) {
            //   let allowedTypes = [
            //     "General Service",
            //     "Irrigation",
            //     "Mulch Request",
            //     "Request for Proposal",
            //     "Plant Request",
            //     "Sod Request",
            //     "Crew, storm or other damage"
            //   ];
            //   let allowedTypeIds = [4, 6, 11, 12, 14, 16, 17];
            //   this.requestTypeItems = this.requestTypeItems.filter(
            //     el =>
            //       allowedTypes.includes(el.name) ||
            //       allowedTypeIds.includes(el.id)
            //   );
            // }
          } else {
            self.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }
        });
    },
    saveServiceRequest() {
      // this.newRequest.title = this.serviceRequest.title;
      this.newRequest.language = this.activeLang;
      this.newRequest.communityId = this.serviceRequest.communityId;

      this.newRequest.parentId = this.serviceRequest.id;
      this.newRequest.isNew = this.requestStatus === "new";
      this.newRequest.isOpen = this.requestStatus === "open";
      this.newRequest.isInProcess = this.requestStatus === "inProcess";
      this.newRequest.isOnHold = this.requestStatus === "onHold";
      this.newRequest.isCompleted = this.requestStatus === "complete";
      this.newRequest.skipNotification =
        process.env.VUE_APP_SKIP_NOTIFICATIONS == "1";

      let requestTypeObj = this.requestTypeItems[0];
      if (
        this.requestTypeItems.filter(el => el.id === this.requestType).length >
        0
      )
        requestTypeObj = this.requestTypeItems.filter(
          el => el.id === this.requestType
        )[0];

      this.newRequest.requestType = {
        id: requestTypeObj.id,
        name: requestTypeObj.name
      };

      this.newRequest.title = this.newRequest.requestType.name;

      // we don't need priority now. set default value on server side

      // let priorityObj = this.priorityItems[0];
      // if (this.priorityItems.filter(el => el.id === this.priority).length > 0)
      //   priorityObj = this.priorityItems.filter(
      //     el => el.id === this.priority
      //   )[0];

      // this.newRequest.priority = {
      //   id: priorityObj.id,
      //   name: priorityObj.name
      // };

      let assignedToObj = this.ynTeamItems[0];
      if (this.ynTeamItems.filter(el => el.id === this.assignedTo).length > 0)
        assignedToObj = this.ynTeamItems.filter(
          el => el.id === this.assignedTo
        )[0];

      this.newRequest.assignedTo = {
        id: assignedToObj.id
      };

      this.newRequest.targetCompletionDate = moment.utc(this.completionDate);
      // this.newRequest.targetCompletionDate = this.serviceRequest.targetCompletionDate;

      this.newRequest.attachments = this.attachmentsObj
        .filter(i => i.url && i.url.length > 0)
        .map(i => {
          return { id: i.fileId, fileUrl: i.url };
        });
      this.newRequest.attachments = this.newRequest.attachments.filter(
        (item, index) => this.newRequest.attachments.indexOf(item) === index
      ); //remove duplicates

      if (
        !this.newRequest.assignedTo ||
        // !this.newRequest.title ||
        !this.newRequest.description ||
        // !this.newRequest.priority ||
        !this.newRequest.requestType
      ) {
        this.snackbarContent =
          "Please, populate all required fields (*) on the form";
        this.snackbarColor = "red";
        this.$snackbar.showMessage({
          content: this.snackbarContent,
          color: this.snackbarColor
        });
        return;
      }

      let self = this;
      this.serviceRequestProcessing = true;
      this.$store
        .dispatch(POST_DATA, {
          listName: `${API_SERVICE_REQUESTS}`,
          data: this.newRequest
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            self.snackbarContent =
              "Service Request has been updated successfully";
            self.snackbarColor = "green";

            self.$router.push({
              name: "CustomerRequests",
              params: { customerId: self.customerId }
            });
          } else {
            self.snackbarContent = response.data;
            self.snackbarColor = "red";
          }
          self.$snackbar.showMessage({
            content: self.snackbarContent,
            color: self.snackbarColor
          });

          self.serviceRequestProcessing = false;
        });
    },
    async getRecipients() {
      // let comunityItems = dataModels.communityDetails;
      let self = this;
      await this.$store
        .dispatch(GET_PAGED, {
          listName: API_EMPLOYEES,
          params: {
            role: "Crew Leader,Branch Manager",
            branch: self.communityInfo.branch.name,
            includeHasAllBranchesAccess: false
          }
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            self.ynTeamItems = response.data;
            self.ynTeamItems.push(self.communityInfo.propertyManager);
            self.ynTeamItems.push(self.communityInfo.accountManager);
          } else {
            self.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }
        });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
    },
    onMultipleAddFile(files) {
      for (var i = 1; i < files.length; i++) {
        let max = Math.max(...this.attachmentsObj.map(i => i.id));
        this.attachmentsObj.push({
          id: (max += 1),
          url: files[i].fileUrl,
          fileId: files[i].id
        });
      }
      let max = Math.max(...this.attachmentsObj.map(i => i.id));
      this.attachmentsObj.push({ id: (max += 1), url: null });
      this.$nextTick(() => files.forEach(f => this.onChange(f)));
    },
    onChange(file) {
      if (file.fileUrl) {
        var found = this.attachmentsObj.find(f => f.url == file.fileUrl);
        found.fileId = file.id;
      }
    },
    onDeleteFile(fileData) {
      let index = this.attachmentsObj.findIndex(f => f.id === fileData.index);
      this.attachmentsObj.splice(index, 1);
    },
    formatDate(date) {
      return dateFormatter.formatEditDate(date);
    },
    formatDateUs(date) {
      // return moment(date).format("MM/DD/YYYY");
      return dateFormatter.formatDateUs(date);
    },
    capitalizeFirstLetter(string) {
      return stringFormatter.capitalizeFirstLetter(string);
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  computed: {
    accept() {
      return "*/*";
    },
    extensions() {
      return "gif,jpg,jpeg,png,webp,mp4,mov,avi,mkv,mpg,vob,wmv,m4v,asf,srt,pdf,doc,docx";
    },
    activeLang() {
      return i18nService.getActiveLanguage();
    }
  }
};
</script>
<style lang="scss">
@media print {
  #kt_aside,
  #kt_header,
  #kt_subheader,
  #syncscape_communityInfo,
  #updateRequestForm {
    display: none !important;
  }
}
</style>
